import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import { useTranslation } from 'react-i18next';
import Button from '../core/button/CoreButton';
import SubSectionRow from '../core/headers/SubSectionRow';
import { SubSectionContent } from '../core/layouts/CommonLayoutStyles';
import ActivateLicenseMinorCTA from './ActivateLicenseMinorCTA';

export default function ActivateLicenseCard() {
    const { t } = useTranslation();
    const currentUserContainer = CurrentUserContainer.useContainer();

    // option to activate license and create new organization only available to free users who have verified emails
    if (!currentUserContainer.hasNoOrgMemberships || !currentUserContainer.isEmailVerified) return null;

    return (
        <>
            <SubSectionRow
                title={t('common:license.upgrade.generic.title')}
                description={t('common:license.upgrade.generic.description')}
            />
            <SubSectionContent>
                <ActivateLicenseMinorCTA center={false} />
                <Button to="/upgrade" $color="secondary">
                    {t('common:billing.viewProducts')}
                </Button>
            </SubSectionContent>
        </>
    );
}
